/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewCreators_itemSearch = {
    readonly pageType: string | null;
    readonly isAttributePage: boolean | null;
    readonly " $refType": "QuickViewCreators_itemSearch";
};
export type QuickViewCreators_itemSearch$data = QuickViewCreators_itemSearch;
export type QuickViewCreators_itemSearch$key = {
    readonly " $data"?: QuickViewCreators_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCreators_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCreators_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAttributePage",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '8e56bc47a548a5d933b393a7b57d25c6';
export default node;
